// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { videoViews10SecConfig } from '@/lib/analytics/kpis/pinterest/videoViews10Sec';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoViews10SecConfig: KpiType<typeof MediaViewerKpiLoader> = {
    ...videoViews10SecConfig,
    loader: MediaViewerKpiLoader
};
